import React from 'react';
import loading_mobile from './Loading_mobile@3x.png';
import loading_web from './Loading_web@3x.png';
import { VoiceLoadingImg } from './style';
import { isMobile } from '@/utils/constants';
const loading = isMobile ? loading_mobile : loading_web;

export default (props: { theme: any }) => (
  <VoiceLoadingImg
    src={props.theme.voiceWebLoadingIconUrl || loading}
    alt="loading"
  />
);
